<template>
  <layout :tenantId="tenantId">
      <h1>{{ i18n.t('LogoutHeader') }}</h1>
      <div v-if="!logoutDone">
        {{ i18n.t('LogoutInProgress') }}
      </div>
      <div v-if="logoutDone" class="loggedOut">
        <p> {{ i18n.t('LoginReasonLoggedOut')}}</p>
        
        <button class="primary" @click="login_click()">{{ i18n.t('Login') }}</button>
      </div>
  </layout>
</template>

<script lang="ts" setup>
import { ref, onMounted } from 'vue';
import { useI18n } from '../i18n-shim';
import layout from './layout.vue';
import { ESignCommonClient } from './esignclient';
import { useRouter } from 'vue-router';
import { refreshUser } from '../userStore';

const props = defineProps(
  {
    tenantId: {
      type: String,
      required: true
    }
  }
)
const logoutDone = ref(false);
const i18n = useI18n();
const client = new ESignCommonClient();
const router= useRouter();
function login_click() {
  const loginUrl = router.currentRoute.value.query.loginUrl;
  if(loginUrl && typeof loginUrl === 'string') {
    window.location.href = loginUrl;
    return; 
  }
}

onMounted(async () => {
  const logoutResult = await client.logout(props.tenantId);
  if(logoutResult.logoutUrl) {
    //const redirectUrl =  `/logout/${props.tenantId}/${props.signFlowId}/${props.signatureId}?lang=${i18n.locale.value}`;
    const redirectUrl =  window.location.pathname + window.location.search;
    window.location.href = logoutResult.logoutUrl + '?ReturnUrl=' + encodeURIComponent(redirectUrl);
  } else {
    logoutDone.value = true;
  }
  await refreshUser(props.tenantId); // updates topmenu computed values
});

</script>

